<label class="switch switch-primary">
    <input
      id="switch1"
      type="checkbox"
      (click)="onChangeEstatus($event.target!)" />
    <span class="switch-slider"></span>
  </label>
  <span class="switch-label">
    <ng-content></ng-content>
  </span>
  